import { render, staticRenderFns } from "./AddressListItem.vue?vue&type=template&id=01a9690a"
import script from "./AddressListItem.vue?vue&type=script&lang=js"
export * from "./AddressListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports